<template>
  <div class="addTask">
    <div class="content">
      <van-row>
        <span class="cell-title">{{$t('append_field.taskName')}}</span>
        <van-field
            v-model="taskName"
            :placeholder="$t('append_field.enterContent')"
            :clearable="!isDisable"
            :disabled="isDisable"
        />
      </van-row>
      <van-row>
        <span class="cell-title">{{$t('append_field.taskGroup')}}</span>
        <van-button block type="default" @click="switchActionSheet('isVisible1')" :msg="taskGroupId">
          {{ taskGroup }}
        </van-button>
        <van-popup v-model="isVisible1" position="bottom" style="height:350px;">
          <van-picker
          v-model="selectedGroup"
          show-toolbar
          :columns="menuItems2.map(res => res.name)"
          :title="$t('append_field.taskGroup')"
          @cancel="isVisible1 = false"
          @confirm="onConfirm"
          ></van-picker>
        </van-popup>
      </van-row>
      <van-row style="padding:10px 0;">
        <span class="cell-title">{{$t('append_field.playMode')}}</span>
        <div class="progremList">
          <van-field name="radio">
            <van-radio-group v-model="radio"  slot="input">
              <van-radio name="1">{{$t('append_field.replaceMode')}}</van-radio>
              <van-radio name="2">{{$t('append_field.appendMode')}}</van-radio>
            </van-radio-group>
          </van-field>
        </div>
      </van-row>
      <van-row v-if="isDataBtnDisable" style="padding:10px 0;">
        <span class="cell-title">{{$t('append_field.selectPrograms')}}</span>
        <van-button block color="#006EFF" icon="plus" @click="showPrograms" :msg="taskGroupId"
                    class="selectProgramBtn">
          <!--选择节目-->
        </van-button>
        <div class="progremList">
          <van-row v-for="(item,index) in progremArr" :key="index">
            <van-col span="2">
              <van-icon name="/static/images/jiemu.png"/>
            </van-col>
            <van-col span="20"><span class="overtext">{{ item.name }}</span></van-col>
            <van-col span="2" style="text-align: right;">
              <van-icon name="cross" @click="moveProgram(item)"/>
            </van-col>
          </van-row>
        </div>
      </van-row>

      <div v-if="!isDataBtnDisable">
        <span class="cell-title">{{$t('append_field.dateRange')}}</span>
        <van-row>
          <van-col span="11">
            <van-button type="default" size="small" class="small" @click="showgroup('sData')">
              <van-icon name="orders-o"/>
              {{ startData }}
            </van-button>
          </van-col>
          <van-col span="2" style="line-height:100%;height:100%;margin-top:10px;text-align: center">---
          </van-col>
          <van-col span="11">
            <van-button type="default" size="small" class="small" @click="showgroup('eData')">
              <van-icon name="orders-o"/>
              {{ endData }}
            </van-button>
          </van-col>
        </van-row>
      </div>
      <div v-if="!isDataBtnDisable" style="margin: 10px 0;">
        <span class="cell-title">{{$t('append_field.timeRange')}}</span>
        <van-row>
          <van-col span="11">
            <van-button type="default" size="small" class="small" @click="showgroup('sTime')">
              <van-icon name="orders-o"/>
              {{ startTime }}
            </van-button>
          </van-col>
          <van-col span="2" style="line-height:100%;height:100%;margin-top:10px;text-align: center">---
          </van-col>
          <van-col span="11">
            <van-button type="default" size="small" class="small" @click="showgroup('eTime')">
              <van-icon name="orders-o"/>
              {{ endTime }}
            </van-button>
          </van-col>
        </van-row>
      </div>
      <div v-if="!isDataBtnDisable">
        <span class="cell-title">{{ $t('append_field.taskPeriod') }}</span>
        <div class="weekliWrap">
          <!--                    <div class="coverWrap" v-if="isDataBtnDisable"></div>-->
          <div class="weekli" @click="weekChoose('1')" :class="isActive1? 'active': ''">{{$t('append_field.mon')}}</div>
          <div class="weekli" @click="weekChoose('2')" :class="isActive2? 'active': ''">{{$t('append_field.tue')}}</div>
          <div class="weekli" @click="weekChoose('3')" :class="isActive3? 'active': ''">{{$t('append_field.wed')}}</div>
          <div class="weekli" @click="weekChoose('4')" :class="isActive4? 'active': ''">{{$t('append_field.thu')}}</div>
          <div class="weekli" @click="weekChoose('5')" :class="isActive5? 'active': ''">{{$t('append_field.fri')}}</div>
          <div class="weekli" @click="weekChoose('6')" :class="isActive6? 'active': ''">{{$t('append_field.sat')}}</div>
          <div class="weekli" @click="weekChoose('7')" :class="isActive7? 'active': ''">{{$t('append_field.sun')}}</div>
        </div>
      </div>
      <div
          style="margin-top:20px;border-top:1px solid #ddd;height:50px;display: flex;justify-content: space-between;align-items: center">
        <van-button type="default" size="small" @click="back">{{$t('append_field.back')}}</van-button>
        <van-button color="#006EFF" size="small" @click="confirmTask">{{$t('append_field.confirm')}}</van-button>
      </div>
    </div>
    <van-popup v-model="isShowStartData" position="bottom">
      <van-datetime-picker
          type="date"
          :title="$t('append_field.selectStartDate')"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="startDataChoose"
          @cancel="isShowStartData = false"
      />
    </van-popup>
    <van-popup v-model="isShowEndData" position="bottom">
      <van-datetime-picker
          type="date"
          :title="$t('append_field.selectEndDate')"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="endDataChoose"
          @cancel="isShowEndData = false"
      />
    </van-popup>
    <van-popup v-model="isShowStartTime" position="bottom">
      <van-datetime-picker
          type="time"
          :title="$t('append_field.selectStartTime')"
          @confirm="startTimeChoose"
          @cancel="isShowStartTime = false"
      />
    </van-popup>
    <van-popup v-model="isShowEndTime" position="bottom">
      <van-datetime-picker
          type="time"
          :title="$t('append_field.selectEndTime')"
          @confirm="endTimeChoose"
          @cancel="isShowEndTime = false"
      />
    </van-popup>
    <!--        节目列表---底部弹出---开始-->
    <van-action-sheet
        v-model="isVisible3"
        :round="isRound"
        style="height:350px;"
    >
      <van-row style="height:40px;line-height:40px;border-bottom:1px solid #ddd;">
        <van-col :span="4">
          <van-button @click="closeGroup(2)" color="#FF5700" size="small"
                      style="width:100%;background:none;color:#EE0A24;border:none;line-height:40px;height:40px;text-indent: -4px;">
            {{$t('append_field.cancel')}}
          </van-button>
        </van-col>
        <van-col :span="16" style="text-align: center">{{$t('append_field.programList')}}</van-col>
        <van-col :span="4">
          <van-button @click="confirmSend3" color="#006EFF" size="small"
                      style="width:100%;background:none;color:#006EFF;border:none;line-height:40px;height:40px;text-indent: -4px;">
            {{$t('append_field.confirm')}}
          </van-button>
        </van-col>
      </van-row>
      <div style="" class="equirpGroupContent scroll_p">
        <!--                activeNames2展开的项的name,这里将index作为nme-->
        <van-collapse class="scroll_p_li" v-model="activeNames3" @change="onCollapseChange3" accordion
                      style="height:300px;overflow-y: auto">
          <van-collapse-item v-for="(item,index) in programsMenuItems3" :key="index" :name="index"
                             :title="item.name"
                             icon="/static/images/etv-folder.png">
            <!--                        select保存复选框的选中的-->
            <van-checkbox-group v-model="progrmasSelect3" @change="onCheckboxGroupChange3"
                                v-if="index === activeNames3">
              <van-cell-group>
                <van-cell
                    v-for="(item2,index2) in data_p"
                    :key="index2"
                    :title="item2.name"
                    value-class="value-class"
                    clickable
                    @click="toggle"
                    style="position: relative;"
                >
                  <van-checkbox :class="'checkboxes-'+index2" :name="item2" shape="square"/>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </van-collapse-item>
        </van-collapse>
      </div>
    </van-action-sheet>
    <!--        节目列表---底部弹出---结束-->
    <!--        终端列表---底部弹出---开始-->
    <van-action-sheet
        v-model="isVisible4"
        :round="isRound"
        style="height:350px;"
    >
      <van-row style="height:40px;line-height:40px;border-bottom:1px solid #ddd;">
        <van-col :span="4">
          <van-button @click="closeGroup(3)" color="#FF5700" size="small"
                      style="width:100%;background:none;color:#EE0A24;border:none;line-height:40px;height:40px;text-indent: -4px;">
            {{$t('append_field.cancel')}}
          </van-button>
        </van-col>
        <van-col :span="16" style="text-align: center">{{$t('append_field.deviceList')}}</van-col>
        <van-col :span="4">
          <van-button @click="confirmSend4" color="#006EFF" size="small"
                      style="width:100%;background:none;color:#006EFF;border:none;line-height:40px;height:40px;text-indent: -4px;">
            {{$t('append_field.confirm')}}
          </van-button>
        </van-col>
      </van-row>
      <div class="equirpGroupContent scroll_m">
        <!--                activeNames2展开的项的name,这里将index作为nme-->
        <van-collapse class="scroll_m_li" v-model="activeNames4" @change="onCollapseChange4" accordion
                      style="height:300px;overflow-y: auto">
          <van-collapse-item v-for="(item,index) in terminalMenuItems4" :key="index" :name="index"
                             :title="item.name"
                             icon="/static/images/etv-folder.png">
            <!--                        select保存复选框的选中的-->
            <!--            {{data_m[0].name}}-->
            <van-checkbox-group v-model="terminalSelect4" @change="onCheckboxGroupChange4"
                                v-if="index === activeNames4">
              <van-cell-group>
                <van-cell
                    v-for="(item2,index2) in data_m"
                    :key="index2"
                    :title="item2.name"
                    value-class="value-class"
                    clickable
                    :data-name="index2"
                    @click="toggle"
                    style="position: relative;"
                    :icon="item2.onlineState == '1' ? '/static/images/icon_dev_online.png' : '/static/images/icon_dev_disonline.png'"
                >
                  <van-checkbox :class="'checkboxes-'+index2" :name="item2.clNo+'-'+item2.clId"
                                shape="square"/>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </van-collapse-item>
        </van-collapse>
      </div>
    </van-action-sheet>
    <!--        终端列表---底部弹出---结束-->
  </div>
</template>

<script>
import qs from 'qs'
import {Toast} from 'vant'

export default {
  name: 'addTask',
  data() {
    return {
      minDate:new Date(2024,0,1),
      maxDate:new Date(2100,10,5),
      isRound: false,
      isVisible1: false,
      taskName: `task-${new Date().getFullYear()}${new Date().getMonth() + 1}${new Date().getDate()}${new Date().getHours()}${new Date().getMinutes() + 1}${new Date().getSeconds()}`,
      isDisable: false,
      taskGroup: '',
      taskGroupId: '',
      border: true,
      isShowStartData: false,
      isShowEndData: false,
      isShowStartTime: false,
      isShowEndTime: false,
      startData: this.$t('append_field.selectStartDates'),
      endData: this.$t('append_field.selectEndDates'),
      startTime: '00:00',
      endTime: '23:59',
      isActive1: true,
      isActive2: true,
      isActive3: true,
      isActive4: true,
      isActive5: true,
      isActive6: true,
      isActive7: true,
      weekArr: [true, true, true, true, true, true, true],
      menuItems2: [],
      groupList: [],
      parentPage: '',
      programesIds: [],
      isDataBtnDisable: false,
      pageTitle: this.$t('append_field.createTask'),
      isVisible3: false,
      activeNames3: '',
      programsMenuItems3: [],
      progrmasSelect3: [],
      programesMsg: this.$t('append_field.selectPrograms'),
      showPicker: false,
      taskGroupNameIndex: '',
      taskGroupName: '',
      isVisible4: false,
      terminalMenuItems4: [],
      activeNames4: '',
      terminalSelect4: [],
      ceEtId: '',
      progremArr: [],
      btnDisable: false,
      allSelectedPrograms: [],
      radio: "1",
      dataList_p: [],
      data_p: [],
      index_p: 0,
      dataList_m: [],
      data_m: [],
      index_m: 0,
      index: 0,
      selectedGroup: '', // 用于van-picker v-model绑定
    }
  },
  computed: {},
  mounted() {
    this.isDataBtnDisable = true
    document.title = this.$t('append_field.addTask')

    if (this.$route.query.progremData) {
      this.btnDisable = true
      // 接收节目制作传过来的值


      this.$route.query.progremData.forEach(item => {
        if (item.pmName || item.name) {
          if (item.pmResolution) {
            this.progremArr.push({name: item.pmName || item.name + '(' + item.pmResolution + ')'})
          } else {
            this.progremArr.push({name: item.pmName || item.name + '(' + item.resolution + ')'})
          }
        }
        let pid = item.id || item.pmId
        item.pid = pid

        this.allSelectedPrograms.push(item)
      })
    } else {
      this.btnDisable = false
    }


    this.parentPage = this.$route.query.parentPage
    this.programesIds = this.$route.query.grogramIds



    if (this.$route.query.parentPage === 'taskdetail') {
      this.pageTitle = this.$t('append_field.editTask')
      this.isDataBtnDisable = false
      this.isDisable = true
      this.taskName = this.$route.query.data.etName
      this.startData = this.$route.query.data.etStartDate
      this.endData = this.$route.query.data.etEndDate
      this.startTime = this.$route.query.data.etStartTime.split(':')[0] + ':' + this.$route.query.data.etStartTime.split(':')[1]
      this.endTime = this.$route.query.data.etEndTime.split(':')[0] + ':' + this.$route.query.data.etEndTime.split(':')[1]
      this.isActive1 = this.$route.query.data.etMon !== 'false'
      this.isActive2 = this.$route.query.data.etTue !== 'false'
      this.isActive3 = this.$route.query.data.etWed !== 'false'
      this.isActive4 = this.$route.query.data.etThur !== 'false'
      this.isActive5 = this.$route.query.data.etFri !== 'false'
      this.isActive6 = this.$route.query.data.etSat !== 'false'
      this.isActive7 = this.$route.query.data.etSun !== 'false'
      this.radio = this.$route.query.data.etPlayMode

      this.$ajax('/etv/selectEqTaskCategoryAll.json').then(res => {
        let arr = res.data.data
        let arr2 = []
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].id == this.$route.query.data.etEcId) {
            this.taskGroup = arr[i].ecName
            this.taskGroupId = arr[i].id
          }
          arr2.push({name: arr[i].ecName, value: arr[i].id})
        }
        this.menuItems2 = arr2
        this.groupList = arr2
      })


    } else {
      this.isDataBtnDisable = true
      this.getNowDate()
      this.$ajax('/etv/selectEqTaskCategoryAll.json').then(res => {
        let arr = res.data.data
        let arr2 = []
        for (var i = 0; i < arr.length; i++) {
          arr2.push({name: arr[i].ecName, value: arr[i].id})
        }
        this.menuItems2 = arr2
        this.groupList = arr2
        if (this.menuItems2.length > 0) {
          const firstGroup = this.menuItems2[0];
          this.selectedGroup = firstGroup.name; // 设置van-picker默认选中的分组
          this.taskGroup = firstGroup.name; // 设置显示的任务分组名称
          this.taskGroupId = firstGroup.value; // 设置任务分组ID或值
        }
      })
    }
    // 如果menuItems2是同步数据，可以在这里进行初始化

  },
  methods: {
    formatter(time) {
      let nowdata =time == null ?  new Date() : new Date(time);
      let year = nowdata.getFullYear();
      let month = nowdata.getMonth() + 1;
      let date = nowdata.getDate();
      let nowtime = year + "-";
      if (month < 10) {
        nowtime += "0";
      }
      nowtime += month + "-";
      if (date < 10) {
        nowtime += "0";
      }
      nowtime += date;

      return nowtime;
    },
    getNowDate() {
      let now = new Date()
      let nextYear = new Date(new Date().setFullYear(now.getFullYear() + 1))
      // 使用内置的函数和模板字符串来格式化日期
      let formatDate = (date) => {
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        // PadStart会添加前导零如果需要的话
        return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
      }
      // 设置开始和结束日期
      this.startData = formatDate(now)
      this.endData = formatDate(nextYear)
      // 设置开始和结束时间
      this.startTime = '00:00'
      this.endTime = '23:59'
    },

    showgroup(res) {

      if (res == 'sData') {
        this.isShowStartData = true
      } else if (res == 'eData') {
        this.isShowEndData = true
      } else if (res == 'sTime') {
        this.isShowStartTime = true
      } else if (res == 'eTime') {
        this.isShowEndTime = true
      }
    },
    startDataChoose(res) {
      this.startData = this.formatter(res)
      this.isShowStartData = false
    },
    endDataChoose(res) {
      this.endData = this.formatter(res)
      this.isShowEndData = false
    },
    startTimeChoose(res) {
      this.startTime = res
      this.isShowStartTime = false
    },
    endTimeChoose(res) {
      this.endTime = res
      this.isShowEndTime = false
    },
    weekChoose(res) {
      if (res == '1') {
        if (this.isActive1) {
          this.isActive1 = false
          this.weekArr[0] = false
        } else {
          this.isActive1 = true
          this.weekArr[0] = true
        }
      } else if (res == '2') {
        if (this.isActive2) {
          this.isActive2 = false
          this.weekArr[1] = false
        } else {
          this.isActive2 = true
          this.weekArr[1] = true
        }
      } else if (res == '3') {
        if (this.isActive3) {
          this.isActive3 = false
          this.weekArr[2] = false
        } else {
          this.isActive3 = true
          this.weekArr[2] = true
        }
      } else if (res == '4') {
        if (this.isActive4) {
          this.isActive4 = false
          this.weekArr[3] = false
        } else {
          this.isActive4 = true
          this.weekArr[3] = true
        }
      } else if (res == '5') {
        if (this.isActive5) {
          this.isActive5 = false
          this.weekArr[4] = false
        } else {
          this.isActive5 = true
          this.weekArr[4] = true
        }
      } else if (res == '6') {
        if (this.isActive6) {
          this.isActive6 = false
          this.weekArr[5] = false
        } else {
          this.isActive6 = true
          this.weekArr[5] = true
        }
      } else if (res == '7') {
        if (this.isActive7) {
          this.isActive7 = false
          this.weekArr[6] = false
        } else {
          this.isActive7 = true
          this.weekArr[6] = true
        }
      }
    },
    switchActionSheet(res) {
      this[`${res}`] = !this[`${res}`]
    },
    confirmTask() {
      if (this.taskName === '') {
        Toast(this.$t('append_field.fillTaskName'))
        return
      }
      if (!this.weekArr.some(dayActive => dayActive)){
        Toast(this.$t('append_field.please_select_date'), 'fail')
        return
      }
      // 创建开始和结束的 Date 对象
      const startDate = new Date(`${this.startData}T${this.startTime}:00`);
      const endDate = new Date(`${this.endData}T${this.endTime}:00`);

      // 检查结束日期是否早于开始日期
      if (endDate < startDate) {
        Toast('结束日期不能早于开始日期');
        return; // 终止函数执行
      }
      // 检查是否至少选择了一个日期
      if (this.$route.query.parentPage === 'taskdetail') {
        this.$ajax.post('/etv/updateEquipmentTask.json', qs.stringify({
          etName: this.taskName,
          etStartDate: this.startData,
          etStartTime: this.startTime + ':00',
          etEndDate: this.endData,
          etEndTime: this.endTime + ':00',
          etState: '1',
          playMode: this.radio,
          id: this.$route.query.data.id,
          etPlayMode: this.radio,
          etLevel: this.radio,
          etEcId: this.taskGroupId,
          etMon: this.isActive1,
          etTue: this.isActive2,
          etWed: this.isActive3,
          etThur: this.isActive4,
          etFri: this.isActive5,
          etSat: this.isActive6,
          etSun: this.isActive7,
        })).then(res => {
          Toast(res.data.msg)
        })
      } else if (this.$route.query.parentPage === 'taskList') {
        if (this.taskGroupId === '') {
          Toast(this.$t('append_field.selectTaskGroup'))
          return
        }
        if (this.allSelectedPrograms.length == 0) {
          Toast(this.$t('append_field.selectProgram'))
          return
        }
        let arr2 = []
        this.allSelectedPrograms.forEach(item => {
          arr2.push({pmId: item.pid, disPlayNo: '1'})
        })

        let postData = {
          task: {
            name: this.taskName,
            level: this.radio,
            taskType: '1',
            startDate: this.startData,
            startTime: this.startTime + ':00',
            endDate: this.endData,
            endTime: this.endTime + ':00',
            etState: '1',
            // Mids: this.$route.query.grogramIds.toString,
            playMode: this.radio,
            etIsLinkScreeen: '1',
            ecId: this.taskGroupId,
            mon: this.isActive1,
            tue: this.isActive2,
            wed: this.isActive3,
            thur: this.isActive4,
            fri: this.isActive5,
            sat: this.isActive6,
            sun: this.isActive7,
            playTimes: '',
          },
          mould: arr2,
        }
        let _this = this
        this.$ajax.post('/etv/insertTaskAndBindMould.json', postData).then(res => {
          // _this.$router.push({ path: '/programs', query: { itemName: 'b'} })
          if (res.data.code == 0) {
            Toast(res.data.msg)
            _this.isVisible4 = true
            _this.getTerinalList()
            _this.ceEtId = res.data.data
          } else {
            Toast(res.data.msg)
          }


        })
      }
    },
    toggle() {
    },
    onConfirm(value, index) {
      this.isVisible1 = false
      this.taskGroupName = value
      this.taskGroupNameIndex = index
      this.taskGroup = value
      this.taskGroupId = this.menuItems2[index].value
    },
    closeGroup() {
      this.isVisible1 = false

      this.isVisible3 = false
      this.programsMenuItems3 = []
      this.isVisible4 = false
      this.terminalMenuItems4 = []
      // 清空控制复选框选中状态的变量
      this.progrmasSelect3 = []
      /*if (res === 3) {
        this.$router.push({path: '/programs', query: {itemName: 'b'}})
      }*/
    },
    onCollapseChange3(activeNames3) {
      this.index = 0
      this.index_p = 0
      if (activeNames3 === '') {
        return
      }
      this.activeNames3 = activeNames3
      this.index_p = activeNames3

      if (this.programsMenuItems3[this.activeNames3].children.length > 0) {

        this.data_p = this.programsMenuItems3[this.activeNames3].children.slice(this.index, 15)
      } else {
        this.data_p = []
      }
    },
    confirmSend3() {
      this.programesMsg = this.$t('append_field.selected') + this.progrmasSelect3.length + this.$t('append_field.programs')
      if (this.progrmasSelect3.length == 0) {
        Toast(this.$t('append_field.selectProgram'))
        return
      }


      let arr1 = this.progremArr
      let arr2 = this.allSelectedPrograms
      arr1.push(...this.progrmasSelect3)
      arr2.push(...this.progrmasSelect3)

      this.progremArr = this.moveSameData(arr1)
      this.allSelectedPrograms = this.moveSameData(arr2)
    // 清空控制复选框选中状态的变量
      this.progrmasSelect3 = []
      this.isVisible3 = false
    },
    moveSameData(array) {
      let obj = {}
      let arr = array.reduce((cur, next) => {
        obj[next.pid] ? "" : obj[next.pid] = true && cur.push(next);
        return cur;
      }, [])
      return arr;
    },
    showPrograms() {
      let _this = this
      _this.isVisible3 = true
      this.$ajax.post('/etv/selectProCategoryProgramMouldTree.json', qs.stringify({
        type: '1',
      })).then(res => {
        _this.programsMenuItems3 = res.data.data.pcList


        const Terminal = document.getElementsByClassName('scroll_p_li')[0]
        Terminal.addEventListener('scroll', _this.handleScroll1)
      })
    },
    //分页加载
    handleScroll1() {
      //滚动条
      const scrollHeight = document.getElementsByClassName('scroll_p')[0].scrollTop
      let clientHeight = document.getElementsByClassName('scroll_p_li')[0].clientHeight
      //真实高度
      if (clientHeight - 350 - scrollHeight < 40) {
        if (this.programsMenuItems3[this.activeNames3].children.slice(this.index * 15, this.index * 15 + 15).length < 15) {
          return
        }
        this.index++
        this.data_p = [...new Set([...this.data_p, ...this.programsMenuItems3[this.activeNames3].children.slice(this.index * 15, this.index * 15 + 15)])]
      }
    },
    handleScroll2() {
      //滚动条
      const scrollHeight = document.getElementsByClassName('scroll_m')[0].scrollTop
      let clientHeight = document.getElementsByClassName('scroll_m_li')[0].clientHeight
      //真实高度
      if (clientHeight - 350 - scrollHeight < 40) {
        if (this.terminalMenuItems4[this.activeNames4].children.slice(this.index * 15, this.index * 15 + 15).length < 15) {
          return
        }
        this.index++
        this.data_m = [...new Set([...this.data_m, ...this.terminalMenuItems4[this.activeNames4].children.slice(this.index * 15, this.index * 15 + 15)])]
      }
    },
    onCheckboxGroupChange3() {
    },
    getTerinalList() {
      let _this = this
      this.$ajax('/etv/selectSeachClientTreeMobile.json').then(res => {
        let arr = res.data.data
        let arr2 = []
        for (var i = 0; i < arr.length; i++) {
          arr2.push({name: arr[i].name, value: arr[i].id, children: arr[i].children})
        }
        _this.terminalMenuItems4 = arr2

        const Terminal = document.getElementsByClassName('scroll_m_li')[0]
        Terminal.addEventListener('scroll', _this.handleScroll2)

      })
    },
    // 选择终端
    onCollapseChange4(activeNames4) {
      this.index = 0
      if (activeNames4 === '') {
        return
      }
      this.activeNames4 = activeNames4
      this.index_m = activeNames4
      if (this.terminalMenuItems4[this.activeNames4].children.length > 0) {
        this.data_m = this.terminalMenuItems4[this.activeNames4].children.slice(this.index, 15)
      } else {
        this.data_m = []
      }
    },
    onCheckboxGroupChange4() {
    },
    confirmSend4() {
      if (this.terminalSelect4.length == 0) {
        Toast(this.$t('append_field.selectDevice'))
        return
      }
      let _this = this
      let postData = {
        ceEtId: _this.ceEtId,
        clientIdList: '',
      }
      let terminalSelectedArr = _this.terminalSelect4
      let noArr = [], idArr = []
      for (var i = 0; i < terminalSelectedArr.length; i++) {
        idArr.push(terminalSelectedArr[i].split('-')[1])
        noArr.push(terminalSelectedArr[i].split('-')[0])
      }

      postData.clientIdList = idArr
      this.$ajax.post('/etv/insertClientEqTask.json', postData).then(res => {
        if (res.data.code == 0) {
          Toast(this.$t('append_field.sendTaskSuccess'))
          _this.$router.push({path: '/program', query: {itemName: 'c'}})
        } else {
          Toast(res.data.msg)
        }
        _this.isVisible4 = false
        _this.terminalSelect4 = []
        _this.activeNames4 = ['1']
        _this.ceEtId = ''

      })
    },
    moveProgram(res) {
      let num = '', num2 = ''
      this.progremArr.forEach((item, index) => {
        if (res.pid == item.pid) {
          num = index;
        }
      })
      this.progremArr.splice(num, 1)
      this.allSelectedPrograms.forEach((item, index) => {
        if (res.pid == item.pid) {
          num2 = index;
        }
      })
      this.allSelectedPrograms.splice(num2, 1)

    },

    back() {
      this.$router.back()
    }
  },
}
</script>

<style lang="scss">
.addTask {
  height: calc(100% - 130px) !important;

  .selectProgramBtn {
    width: 30px;
    height: 20px;
    line-height: 20px;
    padding: 0;
    display: inline-block;
    float: right;
    margin-top: 4px;
  }

  .van-collapse-item__content {
    padding: 0 16px;
  }

  .van-collapse-item__wrapper {
    position: relative;

    .van-cell {

      .van-checkbox {
        justify-content: flex-end;
      }
    }
  }

  .van-action-sheet__header {
    /*background: #006EFF;*/
    color: #006EFF;
    border-bottom: 1px solid #ccc;

    .van-action-sheet__close {
      color: #000;
    }
  }

  .equirpGroupContent {
    max-height: 400px;
    width: 100%;
    overflow-y: auto;
  }


  .content {
    padding: 10px 20px 0 20px;
    height: calc(100% - 0px);
    overflow-y: auto;

    .progremList {
      padding: 0 20px;
      max-height: 200px;
      overflow-y: auto;
      background: #fff;

      .van-cell {
        padding: 10px 0;
        .van-radio {
          margin-bottom: 10px; /* 设置单选按钮之间的间距 */
        }

        .van-radio:last-child {
          margin-bottom: 0; /* 最后一个单选按钮不需要间距 */
        }
        .van-radio-group {
          //display: flex;
          justify-content: space-between;
        }
      }

      .van-row {
        line-height: 40px;
        border-bottom: 1px solid #ddd;

        .van-col {
          display: flex;
          align-items: center;
          height: 40px;
        }

        .van-icon {
          width: 20px;
          height: 20px;

          .van-image {
            width: 100%;
            height: 100%;

          }
        }
      }
    }

    .van-popup--bottom {

      .van-row {
        margin-bottom: 10px;
        border-bottom: 1px solid #ebedf0;
      }
    }

    .cell-title {
      height: 30px;
      line-height: 30px;
    }

    .van-button.small {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      padding: 0 8px;
      height: 40px;
      line-height: 40px;
      font-size:  15px;

      span {
        display: flex;
        align-items: center;
      }
    }

    .weekliWrap {
      display: flex;
      justify-content: space-around;
      position: relative;

      .coverWrap {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 10;
      }

      .weekli {
        width: 32px;
        height: 32px;
        background: #fff;
        border: 1px solid #006EFF;
        color: #006EFF;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .weekli.active {
        background: #006EFF;
        color: #fff;
      }
    }
  }
}
</style>
